import React from 'react';
import styled from 'styled-components';
import { copyFor } from '../../copy/copy';

const SpeakableOrgLink = styled.a`
    color: #ff245e;
    text-decoration: none;
    font-weight: bold;
`;

const ActionButtonDescription = () => (
    <div>
        <p>{copyFor('overlay', 'ActionButtonDescription')}</p>
        <p>
            <SpeakableOrgLink
                href="https://actionbutton.org/"
                rel="noopener noreferrer"
                target="_blank"
            >
                Action Button
            </SpeakableOrgLink>{' '}
            {copyFor('overlay', 'SpeakableDescription')}
        </p>
        <p>{copyFor('overlay', 'stayUpToDate')}</p>
    </div>
);

export default ActionButtonDescription;
